import React, { useEffect, useState } from "react";
import { Modal, Form, Button, Alert, Spinner } from "react-bootstrap";
import { FiLink } from "react-icons/fi";
import { getHost, defaultClientId } from "../utils/utils";

const API_BULK_WEBHOOKS = `${getHost()}/api/monitors/bulk-webhooks`;
const getToken = () => localStorage.getItem("jwt");

const BulkWebhookModal = ({ show, onHide, monitorIds, clients, onSuccess }) => {
  const [selectedClient, setSelectedClient] = useState("");
  const [webhookUrl, setWebhookUrl] = useState("");
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (show) {
      setSelectedClient(defaultClientId(clients));
      setWebhookUrl("");
      setMessage("");
      setIsSuccess(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handleSubmit = async () => {
    if (!selectedClient || !webhookUrl.trim()) return;

    setSaving(true);
    setMessage("");

    try {
      const res = await fetch(API_BULK_WEBHOOKS, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          client_id: selectedClient,
          webhook_url: webhookUrl.trim(),
          monitor_ids: Array.from(monitorIds),
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to add webhooks");

      setIsSuccess(true);
      setMessage(`Webhook added to ${data.updated} monitor${data.updated !== 1 ? "s" : ""}`);

      if (onSuccess) {
        setTimeout(() => onSuccess(), 1500);
      }
    } catch (error) {
      setIsSuccess(false);
      setMessage(error.message || "Failed to add webhooks");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title className="text-main d-flex align-items-start gap-3">
          <FiLink className="fs-24 flex-shrink-0" />
          <div>
            <div className="fs-18 fw-600 lh-1">Bulk Add Webhook</div>
            <div className="fs-14 text-white-45 mt-1">
              Adding to {monitorIds.size} monitor{monitorIds.size !== 1 ? "s" : ""}
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-white modal-white-bg">
        {message && (
          <Alert variant={isSuccess ? "success" : "danger"}>{message}</Alert>
        )}

        <Form.Group className="mb-3">
          <Form.Label className="text-main">Select Group/Client</Form.Label>
          <Form.Select
            value={selectedClient}
            onChange={(e) => setSelectedClient(e.target.value)}
            className="form-input-field rounded-3 text-main custom-select-white fs-16"
          >
            <option value="">Select a group...</option>
            {clients.map((cl) => (
              <option key={cl._id} value={cl._id}>
                {cl.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group>
          <Form.Label className="text-main">Webhook URL</Form.Label>
          <Form.Control
            type="text"
            value={webhookUrl}
            onChange={(e) => setWebhookUrl(e.target.value)}
            placeholder="https://discord.com/api/webhooks/..."
            className="form-input-field"
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button
          className="btn-secondary rounded-3 py-1 px-3 fw-600 fs-12"
          onClick={onHide}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          className="btn-primary rounded-3 py-1 px-3 fw-600 fs-12"
          onClick={handleSubmit}
          disabled={saving || !selectedClient || !webhookUrl.trim()}
        >
          {saving ? <Spinner size="sm" /> : "Add Webhook"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BulkWebhookModal;
